import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubmenuModel } from './models/submenu.model';
import { SubmenuService } from './services/submenu.service';

@Component({
  selector: 'app-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.scss'],
})
export class SubmenuComponent implements OnInit {
  @Input() serviceTabs: SubmenuModel;
  // activeTabs: { [key: string]: boolean } = {};
  public isPrivateUrl: boolean;
  public existPrivateTabs: boolean;
  public existPublicTabs: boolean;

  constructor(
    private _router: Router,
    public submenuService: SubmenuService
  ) {}

  ngOnInit(): void {
    this.isPrivateUrl = this._router.url.includes('/private');
    this.existPublicTabs = this.serviceTabs.publicService ? this.serviceTabs.publicService.tabs.length > 0 : false;
    this.existPrivateTabs = this.serviceTabs.privateService ? this.serviceTabs.privateService.tabs.length > 0 : false;

    // if (this.serviceTabs && this.serviceTabs.privateService.tabs && this.serviceTabs.privateService.tabs.length) {
    //   this.serviceTabs.privateService.tabs.map(x => {
    //     if (this._router.url.includes(x.path)) {
    //       this.activeTabs[x.path] = true;
    //     }
    //   });
    // }
    // if (this.serviceTabs.publicService.tabs.length) {
    //   this.serviceTabs.publicService.tabs.map(x => {
    //     if (this._router.url.includes(x.path)) {
    //       this.activeTabs[x.path] = true;
    //     }
    //   });
    // }
  }

  public goTo(url: string): void {
    this._router.navigate([url]); // Usa el enrutador de Angular
  }
}
